import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-social-registry-form',
  templateUrl: './social-registry-form.component.html',
  styleUrls: ['./social-registry-form.component.css'],
})
export class SocialRegistryFormComponent {
  url: string = 'socialRegistries';
  id!: string;
  form!: FormGroup;

  platformOptions = ['instagram', 'facebook', 'youtube', 'tiktok', 'linkedin'];
  channelOptions = [
    'feed',
    'reel',
    'story',
    'post',
    'carousel',
    'dm_template',
    'comment_template',
  ];
  assetTypeOptions = ['post', 'reel', 'story', 'carousel', 'series_unit'];
  statusOptions = [
    'draft',
    'review',
    'approved',
    'scheduled',
    'published',
    'refresh_due',
    'archived',
    'blocked',
  ];
  verticalOptions = ['courier', 'task_runner', 'bridge'];
  geoScopeTypeOptions = ['city', 'metro', 'zip_cluster', 'region'];

  intentOptions = ['high', 'medium', 'low'];
  riskOptions = ['low', 'medium', 'high'];
  toneOptions = ['premium', 'neutral', 'urgent', 'educational'];
  publishToolOptions = [
    'manual',
    'meta_business_suite',
    'scheduler',
    'make_automation',
  ];

  readOnlyFields = [
    'social_asset_id',
    'platform',
    'vertical',
    'geo_scope_value',
    'service_scope',
    'industry_scope',
    'risk_level',
    'status',
    'content_source_type',
    'content_source_id',
  ];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      social_asset_id: ['', [Validators.required]],
      title_internal: ['', [Validators.required]],
      content_title: [''],
      platform: ['instagram', [Validators.required]],
      channel_target: ['post', [Validators.required]],
      asset_type: ['post', [Validators.required]],
      format_variant: [''],
      status: ['draft', [Validators.required]],
      version: ['1.0'],
      vertical: ['', [Validators.required]],
      geo_scope_type: ['', [Validators.required]],
      geo_scope_value: [''],
      service_scope: [null],
      industry_scope: [null],
      intent_level: ['medium'],
      risk_level: ['low'],
      content_source_type: ['exception_manual'],
      caption: ['', [Validators.required]],
      creative_url: ['', [Validators.required]],
      cta_primary: [''],
      cta_secondary: [''],
      hashtags: [[]],
      tone_profile: ['premium'],
      publish_tool: ['make_automation'],
      scheduled_at: [null],
      published_at: [null],
      published_url: ['', [Validators.required]],
      refresh_cycle_days: [90],
    });

    this.form.get('scheduled_at')?.disable();

    this.form.get('scheduled_at')?.valueChanges.subscribe((val) => {
      if (
        val &&
        (this.form.get('status')?.value === 'approved' ||
          this.form.get('status')?.value === 'scheduled')
      ) {
        this.form.get('status')?.patchValue('scheduled', { emitEvent: false });
      }
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.messageService.add(
        'Por favor complete los campos obligatorios',
        'secondary',
      );
      return;
    }

    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      if (response && response.rst && response.data) {
        const data = response.data;
        console.log('response', response);
        if (data.scheduled_at)
          data.scheduled_at = new Date(data.scheduled_at)
            .toISOString()
            .split('T')[0];
        if (data.published_at)
          data.published_at = new Date(data.published_at)
            .toISOString()
            .split('T')[0];
        this.form.patchValue(data, { emitEvent: false });

        this.readOnlyFields.forEach((field) => {
          this.form.get(field)?.disable();
        });

        const currentStatus = this.form.get('status')?.value;
        if (currentStatus !== 'approved' && currentStatus !== 'scheduled') {
          this.form.get('scheduled_at')?.disable();
        } else {
          this.form.get('scheduled_at')?.enable();
        }
      }
    });
  }

  createData(): void {
    this.dataService
      .postData(`${this.url}/add`, this.form.value)
      .subscribe((response) => {
        if (response && response.rst) {
          this.messageService.add(response.msg, 'info');
          this.router.navigateByUrl('marketing/social/registry');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.dataService
      .putData(`${this.url}/update/${this.id}`, this.form.getRawValue())
      .subscribe((response) => {
        if (response && response.rst) {
          this.messageService.add(response.msg, 'info');
          this.router.navigateByUrl('marketing/social/registry');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }
}
